import React, { useEffect, useRef } from "react";
import { IMG } from "../../../../assets";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./Vision.css";

const textAnimation = {
  hidden: { opacity: 0, y: 30 }, // Starts invisible and below
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }, // Fades in and moves up
};

export default function Vision() {
  const [secondRef, inView] = useInView({ triggerOnce: false });
  const controls = useAnimation();
  const ref = useRef();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [inView, controls]);

  return (
    <div
      ref={ref}
      className="h-auto flex justify-center items-center px-5 font-poppins tracking-wider py-10"
    >
      <div className="max-w-screen-2xl w-full h-auto grid lg:grid-cols-2 grid-cols-1">
        <div className="w-full flex items-center justify-center pl-5 mb-5 md:mb-0 autoshow">
          <img
            src={IMG.MAN}
            alt="black logo"
            className="lg:w-[70%] md:w-[60%] w-[80%] h-auto"
          />
        </div>
        <div className="flex flex-col justify-center items-center lg:pl-5 md:mt-10 lg:mt-0 ">
          <p className="w-full text-start md:text-center lg:text-start lg:text-[60px] md:text-[50px] text-[40px] font-extralight text-secondary">
            Our
          </p>
          <motion.p
            className="w-full text-start md:text-center lg:text-start lg:text-[60px] md:text-[50px] text-[40px] font-extralight text-secondary 2xl:mt-[-4%] lg:mt-[-5%] mt-[-4%]"
            initial="hidden"
            animate={controls}
            variants={textAnimation}
            ref={secondRef}
          >
            <span className="font-bold">Vision</span> &{" "}
            <span className="font-bold">Goals</span>
          </motion.p>
          <p className="pt-5 text-start text-secondary font-poppins tracking-widest ">
            Duis nec eros ipsum. Pellentesque facilisis turpis eu quam iaculis
            finibus. Sed pretium lorem vel risus commodo sodales. Vestibulum
            sollicitudin metus id mauris condimentum, nec faucibus nunc mattis.
            Etiam ut tempor dolor, in dignissim sapien. Sed lobortis ut odio non
            vehicula. Morbi ac nulla ultrices, eleifend nibh ac, facilisis
            libero. Nunc non quam at est posuere pretium ut maximus nulla.
            Aliquam consectetur mauris congue arcu feugiat laoreet.
          </p>
          {/* <p className='pt-5 text-center lg:text-start text-secondary font-poppins'>
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </p> */}
        </div>
      </div>
    </div>
  );
}
